export interface ViaCepAddress {
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  // A API devolve a string "true", não o booleano — só é usado como truthy check.
  erro?: boolean | string;
}

/**
 * ViaCEP é público e não passa pelo BFF — não tem nada do cidadão pra
 * proteger aqui, só devolve endereço a partir de um CEP.
 */
export const viaCepApi = {
  async lookup(cep: string): Promise<ViaCepAddress | null> {
    const digits = cep.replace(/\D/g, '');
    if (digits.length !== 8) return null;

    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!response.ok) return null;

    const data: ViaCepAddress = await response.json();
    return data.erro ? null : data;
  },
};
